import {z} from 'zod';

import {reportFiltersSchema} from './ReportFiltersSchema';

const inProgressOrdersByMonthSchema = z.object({
  month: z.string(),
  inProgressCount: z.number(),
  closedCount: z.number(),
  totalCount: z.number(),
  inProgressPercentage: z.number(),
});

export type InProgressOrdersByMonth = z.infer<typeof inProgressOrdersByMonthSchema>;

const inProgressOrdersSummarySchema = inProgressOrdersByMonthSchema.omit({month: true});

export type InProgressOrdersSummary = z.infer<typeof inProgressOrdersSummarySchema>;

export const inProgressOrdersByMonthResponseSchema = z.object({
  data: z.array(inProgressOrdersByMonthSchema),
  summary: inProgressOrdersSummarySchema,
  filters: reportFiltersSchema,
});

export type InProgressOrdersByMonthResponse = z.infer<typeof inProgressOrdersByMonthResponseSchema>;
